import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Colors } from '../../variables/colors';

@Component({
  selector: 'rt-dot',
  template: '',
  styleUrls: ['./dot.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color + " " + size',
    '[class.has-border]': '!!borderColor',
    '[style.border-color]': 'borderColor || Colors.backgroundWhite ',
  },
})
export class DotComponent {
  @Input() public color: 'unread' | 'notifications' | 'active' | 'archived';
  @Input() public borderColor: Colors | undefined;
  @Input() public size: 'small' | 'medium';

  public Colors = Colors;
}
